import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { BRL, RangePicker, KpiGrid, PeriodChart, PeriodTable } from "./AdAnalyticsView";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdAnalyticsDialog({ ad, onClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [days, setDays] = useState(7);

  useEffect(() => {
    if (!ad) return;
    setLoading(true);
    axios.get(`${API}/ads/${ad.ad_id}/analytics`, { params: { days } })
      .then((r) => setData(r.data))
      .catch((e) => toast.error(e.response?.data?.detail || "Erro ao carregar analytics"))
      .finally(() => setLoading(false));
  }, [ad, days]);

  const b = data?.budget;
  return (
    <Dialog open={!!ad} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="ad-analytics-dialog">
        <DialogHeader><DialogTitle>Analytics · {ad?.title}</DialogTitle></DialogHeader>
        <div className="flex items-center justify-between gap-2 flex-wrap">
          <RangePicker days={days} onChange={setDays} />
          {b && b.budget_type !== "none" && (
            <div className="text-xs text-muted-foreground flex items-center gap-2" data-testid="ad-analytics-budget">
              Orçamento: <b>{b.budget_type === "daily" ? `${BRL(b.daily_budget)}/dia` : `${BRL(b.total_budget)} total`}</b> · gasto {BRL(b.spent_brl)}
              <Badge className={`${b.budget_live ? "bg-emerald-500" : b.budget_status === "completed" ? "bg-slate-500" : "bg-amber-500"} text-white text-[9px]`} title={b.paused_reason || ""}>
                {b.budget_live ? "Veiculando" : b.budget_status === "completed" ? "Concluído" : b.budget_status === "paused" ? "Pausado" : "Limite do dia"}
              </Badge>
            </div>
          )}
        </div>
        {loading && <div className="text-sm text-muted-foreground py-6">Carregando...</div>}
        {!loading && data && (
          <div className="space-y-3">
            <KpiGrid totals={data.totals} />
            <PeriodChart series={data.series} />
            <PeriodTable series={data.series} />
            <p className="text-[11px] text-muted-foreground" data-testid="ad-analytics-lifetime">
              Desde a criação: {Number(data.lifetime.impressions).toLocaleString("pt-BR")} impressões · {Number(data.lifetime.reach).toLocaleString("pt-BR")} pessoas alcançadas · {Number(data.lifetime.clicks).toLocaleString("pt-BR")} cliques · {Number(data.lifetime.conversions).toLocaleString("pt-BR")} conversões (cliques no link de destino).
            </p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
